import { render, staticRenderFns } from "./UploadMian.vue?vue&type=template&id=44248526&scoped=true"
import script from "./UploadMian.vue?vue&type=script&lang=js"
export * from "./UploadMian.vue?vue&type=script&lang=js"
import style0 from "./UploadMian.vue?vue&type=style&index=0&id=44248526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44248526",
  null
  
)

export default component.exports